export const DOWNLOAD_APK_URL = 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk'
